import { as, Chip, Text } from 'folds';
import classNames from 'classnames';
import { CaretDown, CaretRight, chipCaretIcon } from '$components/icons/phosphor';
import * as css from './styles.css';

export const RoomNavCategoryButton = as<'button', { closed?: boolean }>(
  ({ className, closed, children, ...props }, ref) => (
    <Chip
      className={classNames(css.CategoryButton, className)}
      variant="Background"
      radii="400"
      after={
        <span className={css.CategoryButtonIcon}>
          {chipCaretIcon(closed ? CaretRight : CaretDown, { size: 10 })}
        </span>
      }
      {...props}
      ref={ref}
    >
      {children && (
        <Text size="B400" priority="Inherit" truncate className={css.CategoryButtonLabel}>
          {children}
        </Text>
      )}
    </Chip>
  )
);
